import React, { useEffect, useState, useRef } from "react";
import {
  useForm,
} from "react-hook-form";
import { State } from 'country-state-city';
import {
  DescriptionText,
  H1Text,
  H2Text,
  Text,
  SpanText,
  SubmitButton,
  Spinner,
} from "../../design";
import {
  Row,
  Col,
} from 'antd';
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import ErrorMessageModal from "../../components/modal/errorMessage";
import {
  addFundingSourceLink,
  getFundingSourceById,
  getPlaidCreateLinkToken,
  patchContactAddress,
} from "../../api";
import {
  MESSAGES,
  SWIREPAY_URL,
  BENETYPES,
} from "../../appconstants";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import PlaidLinkOpener from "./components/PlaidLinkOpener";
import BackgroundPattern from "../../assets/imgs/background_pattern.png";
import PlaidIcon from "../../assets/imgs/plaid_icon.svg";
import CommonFields from "./components/CommonFields";
import { useSelector } from "react-redux";

type Props = {
  match: Object,
  location: Object,
};

const FundingSourceLink = (props: Props) => {
  const {
    match: {
      params: {
        fundingSourcelinkId,
      },
    },
    location: {
      pathname,
      search,
    },
  } = props;
  const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
  const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
  const [payment, setPayment] = useState(null);
  const [issuerType, setIssuerType] = useState(null);
  const [errorMessage, setErrorMessage] = useState();
  const [bankImageUrl, setBankImageUrl] = useState(null);
  const [partnerImageUrl, setPartnerImageUrl] = useState(null);
  const [isShowSpinner, setShowSpinner] = useState(false);
  const [plaidAccessToken, setPlaidAccessToken] = useState(null);
  const [openPlaidModal, setOpenPlaidModal] = useState(false);
  const [parameter, setParameter] = useState(null);
  const [plaidVerified, setPlaidVerified] = useState(false);
  const [isShowErrorMessage, setShowErrorMessage] = useState(false); // might not be needed
  const [isSubmissionError, setIsSubmissionError] = useState(false);
  const [submissionErrorMsg, setSubmissionErrorMsg] = useState('Submission Failed');
  // const [showCancelButton, setShowCancelButton] = useState(showCancelBt);
  const [showCancelButton, setShowCancelButton] = useState(null);
  const finalCustomerAddressFieldDetails = useRef(null);
  const [preventSubmission, setPreventSubmission] = useState({
    reasonHeader: '',
    reasonMsg: '',
    stopSubmit: false,
  });

  const isMobileView = useSelector(state => state.appConfigInfo.isMobileView);

  const buttonText = !plaidVerified && payment?.contact?.address?.country?.alpha2 === 'US' ? <>Verify with <img src={PlaidIcon} alt="plaid" /></> : "Submit";
  const cancelButtonText = null;
  const disableButtonText = null;
  const currentDateObject = null;
  const planStartDate = null;
  const showCancelBtn = null;
  const cancel = () => {};

  const {
    control,
    handleSubmit,
    errors,
    setValue,
    watch,
    trigger,
    register,
  } = useForm();

  useEffect(() => {
    setShowCancelButton(showCancelBtn);
  }, [showCancelBtn]);

  // this useEffect might not be needed
  useEffect(() => {
    if (errorMessage) {
      setShowErrorMessage(true);
    } else setShowErrorMessage(false);
  }, [errorMessage]);

  const getPaymentButtonDataWithoutSearchValue = async () => {
    setShowSpinner(true);
    try {
      const value = await getFundingSourceById(fundingSourcelinkId);
      if (value) {
        setPayment(value);
        setIssuerType(value.account && value.account.issuer && value.account.issuer.name);
        setBankImageUrl(value.account && value.account.bankImageUrl);
        setPartnerImageUrl(value.account && value.account.partnerImageUrl);
      }
    } catch (e) {
      props.history.push(`${pathname}/error`);
    } finally {
      setShowSpinner(false);
    }
  };

  const error = reason => {
    setErrorMessage(null);
    // const { data: { message, messageCode }, status } = reason;
    const message = reason?.data?.message;
    const messageCode = reason?.data?.messageCode;
    const status = reason?.status;
    if (messageCode === 5102) {
      props.history.push(`${pathname}/error`);
      return;
    }
    setErrorMessage(message);
    if (status === 500) {
      setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
    }
    setTransactionModalOpen(false);
    const errorEl = document.getElementById("error");
    if (null !== errorEl) { errorEl.scrollIntoView(); }
  };

  const getAccessPlaidToken = async () => {
      if (!payment?.contact?.contactType) return;
      setShowSpinner(true);
      try {
          const value = await getPlaidCreateLinkToken({
            gid: fundingSourcelinkId,
            enableManualAuth: payment?.contact?.contactType !== "SENDER",
          });
          if (value?.token) {
              setPlaidAccessToken(value?.token);
              setShowSpinner(false);
          }
      } catch (e) {
          error(e.response);
      } finally {
        setShowSpinner(false);
      }
  };

  const addFundingSource = async (data) => {
    const {
      paymentMethod,
      beneType,
      isDefault,
      // address fields below
      customerStreetAddress,
      customerCity,
      customerState,
      customerPincode,
      customerCountry,
      customerAddressEditState, // don't allow submission when address field are in edit mode
    } = data;
    if (customerAddressEditState) {
      setPreventSubmission({
        reasonHeader: 'Address Fields',
        reasonMsg: 'Save the address field before proceeding with submit',
        stopSubmit: true,
      });
      return;
    } else {
      setPreventSubmission({
        reasonHeader: '',
        reasonMsg: '',
        stopSubmit: false,
      });
    }
    const customerAddress = payment?.contact?.address;
    let newCustomerAddress = null;
    if (customerStreetAddress !== customerAddress?.street
      || customerCity !== customerAddress?.city
      || customerState?.value !== customerAddress?.state
      || customerPincode !== customerAddress?.postalCode
      || customerCountry.value !== customerAddress?.country?.alpha2
    ) {
      newCustomerAddress = {
        street: customerStreetAddress,
        city: customerCity,
        state: customerState?.value,
        postalCode: customerPincode,
        countryCode: customerCountry?.value,
      };
      finalCustomerAddressFieldDetails.current = newCustomerAddress;
    }
    let issuerBank;
    if (beneType === 'VPA') {
      issuerBank = {
        vpa: data.vpa,
        countryCode: payment.account.country.alpha2,
        beneType,
      };
     } else {
      issuerBank = {
        accountNumber: paymentMethod.bank.accountNumber,
        accountType: paymentMethod.bank.accountType,
        businessType : paymentMethod.bank.businessType,
        name: data.name,
        bankName: paymentMethod.bank.bankName,
        countryCode:payment?.contact?.address?.country?.alpha2 ,
        accountHolderName: paymentMethod.bank.accountHolderName,
        beneType,
      };
    }
    const params = payment?.contact?.address?.country?.alpha2 === 'US' ? {
      contactGid: payment.contact.gid,
      issuerBank: {
            businessType: issuerBank?.businessType,
            beneType: issuerBank.beneType,
            countryCode: issuerBank.countryCode,
      },
      isDefault,
    } : {
      contactGid: payment.contact.gid,
      issuerBank,
      isDefault,
    }
    if (beneType !== 'VPA') {
      if (payment.account.country.alpha2 === 'IN') {
        params.issuerBank.routingNumber = data.routingNumber;
      } else {
        params.issuerBank.routingNumber = data.routingNumber;
      }
    }
    if (payment?.contact?.address?.country?.alpha2 === 'US') {
        setParameter(params);
        setOpenPlaidModal(true);
    } else {
      chargeById(params, null, newCustomerAddress);
    }
  };

  const chargeById = async (data, plaidPublicToken, customerAddressField = null) => {
    setTransactionModalOpen(true);
    try {
      let patchContactResponse = null;
      if (customerAddressField) {
        // call api to patch contact here
        patchContactResponse = await patchContactAddress(payment?.contact?.gid, { address: customerAddressField });
      }
      if (patchContactResponse !== null && patchContactResponse?.data?.status !== 'SUCCESS') {
        throw patchContactResponse;
      }
      const value = await addFundingSourceLink(fundingSourcelinkId, {
        ...data,
        issuerBank: {
          ...data.issuerBank,
          plaidPublicToken: plaidPublicToken,
        },
        // status: 'VERIFIED',
      });
      if (value) {
        const { nextActionUrl, redirectUri } = value;
        if (nextActionUrl) {
          window.location = nextActionUrl;
          return;
        }
        setTransactionModalOpen(false);
        setTransactionSuccessModalOpen(true);
        setTimeout(function () {
          const redirectUrl = redirectUri ? redirectUri : SWIREPAY_URL;
          const urlPath = redirectUrl.includes("?");
          if (urlPath) {
            window.location = `${redirectUrl}&sp-fundingsource-link=${fundingSourcelinkId}`;
          } else if (redirectUrl && !urlPath) {
            window.location = `${redirectUrl}?sp-fundingsource-link=${fundingSourcelinkId}`;
          }
        }, 5000);
      }
    } catch (reason) {
      setIsSubmissionError(true);
      setSubmissionErrorMsg(reason?.data?.message ? `Submission Error: ${reason?.data?.message}` : 'Submission Error');
      error(reason);
    } finally {
      finalCustomerAddressFieldDetails.current = null;
    }
  };

  useEffect(() => {
    getPaymentButtonDataWithoutSearchValue();
  }, [fundingSourcelinkId]);

  useEffect(() => {
    if (payment?.contact?.contactType && fundingSourcelinkId) {
      getAccessPlaidToken();
    }
  }, [payment, fundingSourcelinkId]);

  const onSubmit = data => {
    const {
      name,
      email,
      phone,
      countryCallingCode,
      vpa,
      businessType,
      bankName,
      accountType,
      accountNumber,
      accountHolderName,
      routingNumber,
    } = data;
    const phoneNumber = countryCallingCode && countryCallingCode.value && `${countryCallingCode.value}${phone}`;
    const customer = { name, email, phoneNumber };
    const BankName = bankName && bankName.trim();
    const AccountHolderName = bankName && accountHolderName.trim();
    const Route = bankName && routingNumber.trim();
    const AccountNum = bankName && accountNumber.trim();
    const beneType = BENETYPES.BANK;
    const paymentMethod = {
      bank: {
        bankName: BankName,
        accountHolderName: AccountHolderName,
        businessType: businessType?.value,
        accountType: accountType?.value === "CURRENT ACCOUNT" ? "CURRENT" : accountType?.value,
        accountNumber: AccountNum,
        routingNumber: Route,
      },
    };
    const finalData = {
      ...data,
      phoneNumber,
      customer,
      paymentMethod,
      beneType,
      vpa,
    };
    if (addFundingSource) { addFundingSource(finalData) }
  };

  const onCancel = () => { showCancelButton && cancel && cancel(); };

  const customH2TextStyle = {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: '24px',
    fontStyle: 'bold',
    color: '#000000',
    marginTop: '40px',
    marginBottom: '5px',
  };

  const customLabelTextStyle = {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: '14px',
    fontStyle: 'regular',
    color: '#000000',
    // marginTop: '20px',
    // marginBottom: '5px',
  };

  const customSubmitButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    padding: '10px 20px',
    borderRadius: '30px',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
  };

  return (
    <Row>
      <Col
        span={24}
        style={{
          backgroundColor: '#2B2C4C',
          minHeight: '100vh',
          width: '100vw',
          display: 'flex',
          flexWrap: 'nowrap',
          justifyContent: 'center',
          alignContent: 'flex-start',
          alignItems: 'center',
          overflowY: 'auto',
          paddingTop: isMobileView ? '0px' : '7vh',
          paddingBottom: isMobileView ? '0px' : '5vh',
        }}
      >
        <img
          src={BackgroundPattern}
          alt="background pattern"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
        {/* centered container */}
        <Row
          style={{
            backgroundColor: '#FFFFFF',
            position: 'relative',
            zIndex: '10',
            height: 'auto',
            // maxHeight: '100vh',
            maxWidth: '900px',
            width: isMobileView ? '100vw' : '60vw',
            borderRadius: '1vw',
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'nowrap',
            justifyContent: 'start',
            alignContent: 'center',
            alignItems: 'center',
            // marginBottom: isMobileView ? '0px' : '5vh',
            margin: 'auto',
          }}
          justify="center"
        >
          <Col span={24}>
            {/* header container */}
            <Row
              style={{
                backgroundColor: '#F9FAFB',
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'nowrap',
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
                padding: '20px',
                borderTopLeftRadius: '1vw',
                borderTopRightRadius: '1vw',
                width: '100%',
                height: '30%',
              }}
            >
              <Col span={24}>
                {/* centered logo image */}
                <Row>
                  <Col
                    span={24}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      flexWrap: 'nowrap',
                      justifyContent: 'start',
                      alignContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      padding: `1vh 0px 2vh`,
                    }}
                  >
                    {
                      (payment && payment.account && payment.account.largeLogo) && (
                        <img
                          src={payment.account.largeLogo}
                          style={{
                            width: '125px',
                            objectFit: 'cover',
                          }}
                          alt="account logo"
                        />
                      )
                    }
                  </Col>
                </Row>
                {/* funding source heading */}
                <Row>
                  <Col span={24}>
                    <H1Text
                      fontSize="20px"
                      fontWeight={400}
                      lineHeight="30px"
                      fontStyle="normal"
                      color="#364153"
                    >
                      Funding Source Link
                    </H1Text>
                  </Col>
                </Row>
                {/* center box with account name */}
                <Row
                  style={{
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    flexDirection: 'column',
                    flexWrap: 'nowrap',
                    justifyContent: 'start',
                    alignContent: 'center',
                    alignItems: 'center',
                    borderRadius: '10px',
                    maxWidth: '100%',
                  }}
                >
                  <Col span={24}>
                    <Row>
                      <Col span={24}>
                        <H2Text
                          fontSize="16px"
                          fontWeight={400}
                          lineHeight="24px"
                          fontStyle="normal"
                          color="#6A7282"
                        >
                          TRANSFERS FROM
                        </H2Text>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <DescriptionText>
                          {payment && payment.account && payment.account.name}
                        </DescriptionText>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* container with fields */}
            <Row>
              <Col
                span={24}
                style={{
                  backgroundColor: '#FFFFFF',
                  display: 'flex',
                  flexDirection: 'column',
                  flexWrap: 'nowrap',
                  justifyContent: 'start',
                  alignContent: 'center',
                  alignItems: 'flex-start',
                  width: '100%',
                  padding: `2vh ${ isMobileView ? '5vw' : '2vw'} 1vh`,
                  borderRadius: '1vw',
                }}
              >
                {/* heading */}
                <Row
                  style={{
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    flexDirection: 'column',
                    flexWrap: 'nowrap',
                    justifyContent: 'start',
                    alignContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  <Col span={24}>
                    <Text
                      className="px-1 px-md-4"
                      paddingTop="8px"
                      paddingBottom="8px"
                      fontSize="16px"
                      fontWeight={400}
                      lineHeight="24px"
                      fontStyle="normal"
                      color="#1E2939"
                      textAlign="center"
                    >
                      Please provide a valid
                      {payment?.account?.currency?.countryAlpha2 === 'US' && 'US'}
                      {payment?.account?.currency?.countryAlpha2 === 'IN' && 'Indian'}
                      {payment?.account?.currency?.countryAlpha2 === 'CA' && 'Canadian'}
                      bank account to receive funds from {payment?.account?.name}
                    </Text>
                  </Col>
                </Row>
                {/* US plaid description */}
                <Row
                  style={{
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    flexDirection: 'column',
                    flexWrap: 'nowrap',
                    justifyContent: 'start',
                    alignContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  <Col span={24}>
                    {payment?.account?.currency?.countryAlpha2 === 'US' && (
                      <Text
                        fontSize="16px"
                        fontWeight={400}
                        lineHeight="24px"
                        fontStyle="normal"
                        color="#4A5565"
                        textAlign="center"
                      >
                        Swirepay uses Plaid to securely protect your bank information. Plaid is trusted by
                        thousands of financial institutions, and your login stays private. Prefer not to log in?
                        You can verify your account manually with a test deposit.
                      </Text>
                    )}
                  </Col>
                </Row>
                {/* form */}
                <Row
                  style={{
                    width: '100%',
                  }}
                >
                  <Col
                    span={24}
                    style={{
                      backgroundColor: '#FFFFFF',
                      display: 'flex',
                      flexDirection: 'column',
                      flexWrap: 'nowrap',
                      alignContent: 'center',
                      alignItems: 'flex-start',
                      width: '100%',
                    }}
                  >
                    <form
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit(onSubmit)(e);
                      }}
                      onChange={() => setShowErrorMessage(false)}
                      style={{
                        width: '100%',
                        height: '60%'
                      }}
                    >
                      <CommonFields
                        errors={errors}
                        control={control}
                        errorMsg={errorMessage}
                        setValue={setValue}
                        watch={watch}
                        trigger={trigger}
                        register={register}
                        preFillCustomer={payment?.contact}
                        customerDisabled={true}
                        customerValidation={false}
                        setShowErrorMessage={setShowErrorMessage}
                        alpha2={payment?.contact?.address?.country?.alpha2}
                        isMobileView={isMobileView}
                        customH2TextStyle={customH2TextStyle}
                        customLabelTextStyle={customLabelTextStyle}
                      />
                      {/* <IndiaFields />*/}
                      <div className="px-1 px-md-4">
                        <Row>
                          <Col
                            span={24}
                            style={{
                              backgroundColor: '#FFFFFF',
                              display: 'flex',
                              flexDirection: 'column',
                              flexWrap: 'nowrap',
                              alignContent: 'center',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            {
                              showCancelButton && cancel &&
                              <SpanText
                                onClick={onCancel}
                                cursor="pointer"
                                color="#40A9FF"
                                className="cursor-pointer m-3 pt-3"
                              >{cancelButtonText || "Cancel"}</SpanText>
                            }
                            {disableButtonText && (planStartDate < currentDateObject) ?
                              (
                                <SubmitButton
                                  type="submit"
                                  disabled
                                  style={{
                                    ...customSubmitButtonStyle,
                                  }}
                                >{buttonText || "PAY"}</SubmitButton>
                              )
                              : (
                                <SubmitButton
                                  type="submit"
                                  disabled={!plaidAccessToken}
                                  style={{
                                    ...customSubmitButtonStyle
                                  }}
                                >{buttonText || "Submit"}</SubmitButton>
                              )
                            }
                          </Col>
                        </Row>
                        {/* {isShowErrorMessage && <PaymentError header={errorHeader} message={errorMsg} />} */}
                        {(disableButtonText && (planStartDate < currentDateObject)) && <PaymentError header={disableButtonText} message={'For more information, please contact support@swirepay.com'} />}
                        {preventSubmission?.stopSubmit && <PaymentError header={preventSubmission?.reasonHeader} message={preventSubmission?.reasonMsg}/>}
                      </div>
                    </form>
                  </Col>
                </Row>
                {/* support details */}
                <Row
                  style={{
                    width: '100%',
                  }}
                >
                  <Col
                    span={24}
                    style={{
                      backgroundColor: '#FFFFFF',
                      display: 'flex',
                      flexDirection: 'column',
                      flexWrap: 'nowrap',
                      alignContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      marginTop: '1vh',
                    }}
                  >
                    <Support
                      email={payment?.support?.email}
                      partnerImageUrl={partnerImageUrl}
                      bankImageUrl={bankImageUrl}
                      whiteLabel={payment?.account?.whiteLabel}
                      phone={payment?.support?.phone}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        {plaidAccessToken && openPlaidModal && (
          <PlaidLinkOpener
            token={plaidAccessToken}
            onClose={() => window.location = window.location.href}
            // eslint-disable-next-line camelcase
            onSuccess={(public_token, metadata) => {
              setPlaidVerified(true);
              chargeById(parameter, public_token, finalCustomerAddressFieldDetails?.current);
            }}
            onError={(err, metadata) => {
              setPlaidVerified(false);
              setIsSubmissionError(true);
              setSubmissionErrorMsg(err?.display_message ?? 'Submission Error');
            }}
          />
        )}
        <TransactionModal body={"Creating Funding Source"} header={"Your Bank Account has been successfully linked"} isOpen={isTransactionModalOpen} />
        <SuccessModal isOpen={isTransactionSuccessModalOpen} successMsg={"Funding Source Created"} />
        <ErrorMessageModal isOpen={isSubmissionError} errorMsg={submissionErrorMsg} />
        <Spinner isOpen={isShowSpinner} />
      </Col>
    </Row>
  );
};

export default FundingSourceLink;
